import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { User } from '@damofire/data-security';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule, TranslatePipe],
})
export class ContactCardComponent {
  @Input()
  title: string;

  @Input()
  user: User;

  userPhone(): string {
    if (this.user.phone?.length) {
      return this.user.phone[0].replace(/\D+/g, '');
    }

    return '';
  }
}
